import styles from './Result.module.css';
import { motion } from 'framer-motion';

import posterDefault from '../../assets/images/poster.png';
import bgDefaultVideo from '../../assets/video/bgVideo.mp4';

export const Result = ({ vars, bgVideo, bgPoster }) => {
  let correctVar = vars?.find((el) => el.correct);

  if (!vars || !correctVar) {
    return null;
  }

  let text = correctVar.comment?.split('№') || [];

  return (
    <div className={styles.wrapper}>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1.1, 1] }}
        transition={{ times: [0, 0.85, 1], duration: 0.73, ease: 'easeOut' }}
        className={styles.playerBlock}
      >
        {correctVar?.varImgUrl && (
          <img
            src={correctVar?.varImgUrl}
            alt="player"
            className={styles.playerImg}
          />
        )}
        {text[0]?.trim() && (
          <div className={styles.nameBlock}>
            <div className={styles.name}>{text[0]?.trim()}</div>
          </div>
        )}
      </motion.div>
      <motion.div
        className={styles.number}
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1.1, 1] }}
        transition={{
          times: [0, 0.85, 1],
          duration: 0.73,
          ease: 'easeOut',
          delay: 0.66,
        }}
      >
        {text[1]?.trim() && (
          <>
            №<span>{text[1]?.trim()}</span>
          </>
        )}
      </motion.div>

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.videoBg}
        poster={bgVideo === '1' ? posterDefault : bgPoster}
      >
        <source
          src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
          type="video/mp4"
        ></source>
      </video>
    </div>
  );
};
